import { vivaEngageHeroBannerDarkPath, vivaEngageHeroBannerPath } from '@ms/yammer-web-components/dist/images';
import { PageLayoutHeroBanner, PageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { useTheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import React, { ReactNode, useCallback } from 'react';

import { useShouldHaveHeroBanner } from './useShouldHaveHeroBanner';

export interface HeroBannerCallbackOptions {
  readonly hasHeader: boolean;
  readonly noSpacing: boolean;
  readonly width: PageLayoutWidth;
}

type UseHeroBannerCallback = () => (options: HeroBannerCallbackOptions) => ReactNode;
export const useHeroBannerCallback: UseHeroBannerCallback = () => {
  const shouldHaveHeroBanner = useShouldHaveHeroBanner();
  const { isInverted } = useTheme();

  return useCallback(
    ({ hasHeader, noSpacing, width }) => {
      if (!shouldHaveHeroBanner) {
        return null;
      }

      const heroBannerPath = isInverted ? vivaEngageHeroBannerDarkPath : vivaEngageHeroBannerPath;

      return <PageLayoutHeroBanner imgSrc={heroBannerPath} hasHeader={hasHeader} noSpacing={noSpacing} width={width} />;
    },
    [isInverted, shouldHaveHeroBanner]
  );
};
